
import WholeSaleReportService from "../services/wholesale.report.service";

const state = {
	daily: 0,
	monthly: 0,
	inDateRange: 0,
	byEmployee: 0,
	total: 0,
	paymentTypeCard: [],
	reportSearchable: [],
	monitoringSearchable: [],
	columns: [
		{
			key: 'afterSaleSum',
			label: 'AfterSaleSum',
			'class': 'td-30',
			visible: true,
			changebale: false
		},
		{
			key: 'SaleSum',
			label: 'SaleSum',
			'class': 'td-30',
			visible: true,
			changebale: true
		},

	]
};


const getters = {

	getDaily: (state) => {
		return state.daily
	},
	getSearchReport: (state) => {
		if (state.reportSearchable) {
			return state.reportSearchable;
		} else {
			return 0;
		}
	},
	getMonthly: state => state.monthly,
	getTotal: state => state.total,
	getColums: state => state.columns,
	getByEmployee: state => state.byEmployee,
	getInDateRange: state => state.inDateRange,
	getPaymentTypeCard: state => state.paymentTypeCard
};


const actions = {


	/**
	 * get daily sum
	 * @returns {*}
	 */
	async getDailySum({commit}, data) {
		try {
			await WholeSaleReportService.daily(data).then(response => {
				commit('setDaily', response.data);
			});
		} catch (e) {
			return false
		}
	},
	/**
	 * get monthly sum
	 * @returns {*}
	 */
	async getMonthlySum({commit}, data) {
		try {
			WholeSaleReportService.monthly(data).then(response => {
				commit('setMonthly', response.data);
			});
		} catch (e) {
			return false
		}
	},

	async searchReportStore({commit}, data) {
		try {
			WholeSaleReportService.searchReport(data).then(response => {
				commit('setSearchResponse', response.data);
			});
		} catch (e) {
			return false
		}
	},

	// async searchReportForMonitoring({commit}, data) {
	// 	try {
	// 		await PosReportService.reportCategoryForMonitoring(data).then(response => {
	// 			commit('setSearchForMonitoringResponse', response.data);
	// 		});
	// 	} catch (e) {
	// 		return false
	// 	}
	// },
	// async searchForMonitoringDiogram({commit}, data) {
	// 	try {
	// 		await PosReportService.reportMonitoringForDiogram(data).then(response => {
	// 			commit('setSearchForMonitoringDiogram', response.data);
	// 		});
	// 	} catch (e) {
	// 		return false
	// 	}
	// },

	async getByEmployeeId({commit}, data) {
		try {
			await WholeSaleReportService.getByEmployee(data).then(response => {
				commit('setEmployee', response.data);
			});
		} catch (e) {
			return false
		}
	},
	async getByDate({commit}, data) {
		try {
			await WholeSaleReportService.inDateRange(data).then(response => {
				commit('setDate', response.data);
			});
		} catch (e) {
			return false
		}
	},

	async paymentTypeCards({commit}) {
		try {
			WholeSaleReportService.getPaymentTypeCard().then(response => {
				commit('setPaymentTypeCard', response.data);
			});
		} catch (e) {
			return false
		}
	}

};

const mutations = {
	setSearchForMonitoringDiogram(state, response) {
	},
	setSearchForMonitoringResponse(state, response) {
		state.monitoringSearchable = response;
	},
	setSearchResponse(state, response) {
		state.reportSearchable = response;
	},
	setDaily: (state, data) => {
		state.daily = data
	},
	setMonthly: (state, data) => {
		state.monthly = data
	},
	setEmployee: (state, data) => {
		state.byEmployee = data
	},
	setDate: (state, data) => {
		state.inDateRange = data
	},
	setPaymentTypeCard: (state, data) => {
		state.paymentTypeCard = data
	},
	resetReportSearch(state, array) {
		state.reportSearchable = array;
	}

};

export const wholeSaleReport = {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
};
